import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostBeneficiaryToken,
	PostBeneficiaryTokenModel,
	PostBeneficiaryTokenParams,
} from 'domain/usecases';

export class RemotePostBeneficiaryToken implements PostBeneficiaryToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostBeneficiaryTokenModel>,
	) {}

	async post({
		signal,
		...params
	}: PostBeneficiaryTokenParams): Promise<PostBeneficiaryTokenModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
